__webpack_require__.p = "https://app-club-microfrontends-prod.cp.hotmart.com/app-membership-community-management/_current/";